import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { Navbar, Nav, Container, NavDropdown } from "react-bootstrap";
import { current, logout } from "../Redux/Actions/AuthActions";
import logo from "../image/Logspintoss.png";
import "./NavAuth.css";

const NavAuth = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const token = localStorage.getItem("token");
  const user = useSelector((state) => state.AuthReducer?.user);

  useEffect(() => {
    if (token) {
      dispatch(current());
    }
  }, [dispatch, token]);

  // Vérification plus robuste du rôle
  const isAdmin = user?.role === 'admin';
  const isUserSpintoss = user?.role === 'userspintoss';
  const isUseradmin = user?.role === 'useradmin'

  const handleLogout = () => {
    dispatch(logout());
    navigate("/Welcome");
    window.location.reload();
  };

  return (
    <Navbar 
      bg="warning" 
      variant="light" 
      fixed="top" 
      expand="lg" 
      className="custom-navbar"
      collapseOnSelect
    >
      <Container fluid>
        {/* Logo et Toggle */}
        <Navbar.Brand as={Link} to="/Welcome" className="d-flex align-items-center">
          <img
            src={logo}
            alt="Logo"
            height="60"
            color="black"
            className="d-inline-block align-top"
          />
        </Navbar.Brand>
        
        {/* Bouton hamburger pour mobile */}
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="ms-auto"> {/* ms-auto pour aligner à droite */}
            {token && user ? (
              <>

                {/* Menu Inventaire */}
                { <NavDropdown title="Inventaire" id="inventaire-dropdown">
                  {(isAdmin || isUseradmin) && <NavDropdown.Item as={Link} to="/ApercuStock">Aperçu du stock</NavDropdown.Item>}
                  {(isAdmin || isUseradmin) && <NavDropdown.Item as={Link} to="/UpdateStock">Mise à jour du stock</NavDropdown.Item>}
                  {(isAdmin || isUserSpintoss || isUseradmin) && <NavDropdown.Item as={Link} to="/daily-inventory">Inventaire Journalier </NavDropdown.Item>}
                  {(isAdmin || isUseradmin) && <NavDropdown.Item as={Link} to="/inventory-comparison">Rapports des Inventaires </NavDropdown.Item>}
                  {(isAdmin || isUseradmin) && <NavDropdown.Item as={Link} to="/daily-inventory-admin">Gestions des Inventaires</NavDropdown.Item>}
                  
                </NavDropdown>}

                {/* Menu Rapports */}
                <NavDropdown title="Rapports" id="rapports-dropdown">
                  {isAdmin && <NavDropdown.Item as={Link} to="/Margespin">Etat de marge</NavDropdown.Item>}
                  {(isAdmin || isUseradmin) && <NavDropdown.Item as={Link} to="/BestSell">Meilleurs Ventes</NavDropdown.Item>}
                  {(isAdmin || isUserSpintoss || isUseradmin) && <NavDropdown.Item as={Link} to="/TicketReport">Rapport des tickets</NavDropdown.Item>}
                  {(isAdmin || isUserSpintoss) && <NavDropdown.Item as={Link} to="/ticketpersonnel">Consommation du personnel</NavDropdown.Item>}
                 {/*  {(isAdmin || isUserSpintoss) && <NavDropdown.Item as={Link} to="/AddRapportsSpintoss">Rapports</NavDropdown.Item>} */}
                {/*   {isAdmin && <NavDropdown.Item as={Link} to="/ListRapportsSpintoss">Liste des Rapports</NavDropdown.Item>} */}
                  {(isAdmin || isUserSpintoss) && <NavDropdown.Item as={Link} to="/Cloture">Cloture</NavDropdown.Item>}
                  {isAdmin && <NavDropdown.Item as={Link} to="/GlobalClosure">Cloture Globale</NavDropdown.Item>}
                  {isUserSpintoss && <NavDropdown.Item as={Link} to="/ApercuStockUser">Aperçu du stock</NavDropdown.Item>}
                  {(isAdmin || isUserSpintoss) && <NavDropdown.Item as={Link} to="/PerformanceDashboard">Performance</NavDropdown.Item>}
                  {isAdmin && <NavDropdown.Item as={Link} to="/AdminExpensesManager">Administration des charges </NavDropdown.Item>}
                  
                </NavDropdown>

                {/* Menu Ajouts */}
                {
                <NavDropdown title="Les Ajouts" id="ajouts-dropdown">
                  {(isAdmin || isUseradmin || isUseradmin) && <NavDropdown.Item as={Link} to="/AjoutFrs">Ajouter un fournisseur</NavDropdown.Item>}
                  {(isAdmin || isUseradmin) && <NavDropdown.Item as={Link} to="/AjoutIngredient">Ajouter un ingrédient</NavDropdown.Item>}
                  {(isAdmin || isUserSpintoss || isUseradmin) && <NavDropdown.Item as={Link} to="/AjoutFacture">Ajouter une facture</NavDropdown.Item>}
                   {(isAdmin || isUserSpintoss || isUseradmin) && <NavDropdown.Item as={Link} to="/AllInvoice"> Nos factures</NavDropdown.Item>}
                </NavDropdown>
                }

                {/* Menu Fiches techniques */}
                {isAdmin && (
                <NavDropdown title="Fiches Techniques" id="fiches-dropdown">
                  {(isAdmin || isUseradmin)  && <NavDropdown.Item as={Link} to="/TechnicSheet">Création des fiches techniques</NavDropdown.Item>}
                  {(isAdmin || isUseradmin) && <NavDropdown.Item as={Link} to="/SubTechnicSheet">Création des Sous fiches techniques</NavDropdown.Item>}
                  {(isAdmin || isUseradmin) && <NavDropdown.Item as={Link} to="/ListTechnicSheet">Liste des fiches techniques</NavDropdown.Item>}
                </NavDropdown>
                )}

                {/* Menu Produits */}
                <NavDropdown title="Produits" id="produits-dropdown">
                 {(isAdmin || isUserSpintoss)  && <NavDropdown.Item as={Link} to="/ListProduct">Nos produits</NavDropdown.Item>}
                 {(isAdmin || isUserSpintoss)  && <NavDropdown.Item as={Link} to="/TicketCaisseS">Rapport de Caisse</NavDropdown.Item>}
                {(isAdmin || isUserSpintoss)  &&<NavDropdown.Item as={Link} to="/CardRegistration">Carte FID</NavDropdown.Item>}
                  
                  {(isAdmin || isUseradmin) && <NavDropdown.Item as={Link} to="/ProductM">Création des produits</NavDropdown.Item>}
                  {(isAdmin || isUseradmin) && <NavDropdown.Item as={Link} to="/Deals">Création des deals</NavDropdown.Item>}
                  
                </NavDropdown>

                <NavDropdown title="Suivi des Ordres" id="ordres-dropdown">
                  {(isAdmin || isUserSpintoss) && <NavDropdown.Item as={Link} to="/KitchenOrder">Ordres Cuisine</NavDropdown.Item>}
                  {(isAdmin || isUserSpintoss) && <NavDropdown.Item as={Link} to="/BeverageOrder">Ordres Comptoire</NavDropdown.Item>}
                  {(isAdmin || isUserSpintoss || isUseradmin) && <NavDropdown.Item as={Link} to="/TimeOrder">Temps des commandes</NavDropdown.Item>}
                  {(isAdmin || isUserSpintoss) && <NavDropdown.Item as={Link} to="/Addition">Liste des additions</NavDropdown.Item>}
                  {(isAdmin || isUseradmin) && <NavDropdown.Item as={Link} to="/TimeCheck">Performance du Services</NavDropdown.Item>}
                </NavDropdown>

                {/* Menu Parametrage */}
                {isAdmin && (
                <NavDropdown title="Paramétrage" id="parametrage-dropdown">
                 {/* {isAdmin && <NavDropdown.Item as={Link} to="/ConfigManager">Configuration Manager</NavDropdown.Item>} */}
                  {isAdmin && <NavDropdown.Item as={Link} to="/ConfigInterface">Interface</NavDropdown.Item>}
                  {/* {isAdmin && <NavDropdown.Item as={Link} to="/MenuWrapper">Menu Wrapper</NavDropdown.Item>} */}
                  {isAdmin && <NavDropdown.Item as={Link} to="/PointsGestion">Gestion des points</NavDropdown.Item>}
                  {isAdmin && <NavDropdown.Item as={Link} to="/QrCodeScanner">QR Code</NavDropdown.Item>}
                </NavDropdown>)}

                {/* Admin-specific Links */}
                {isAdmin && <Nav.Link as={Link} to="/Register">Register</Nav.Link>}

                {/* Déconnexion */}
                <Nav.Link onClick={handleLogout} className="logout-link">
                  Déconnexion
                </Nav.Link>
              </>
            ) : (
              <>
                {/* Liens pour les utilisateurs non connectés */}
                <Nav.Link as={Link} to="/Welcome">
                  Welcome to SPINTOSS
                </Nav.Link>
                <Nav.Link as={Link} to="/Login">
                  Login
                </Nav.Link>
              </>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavAuth;